let hostname = 'http://localhost:8000/api/v1';

if (process.env.REACT_APP_STAGE === 'test') {
  hostname = 'https://geneidapitest.mwe.cloud/api/v1';
} else if (process.env.REACT_APP_STAGE === 'prod') {
  hostname = 'https://api.geneidportal.com/api/v1';
}
export default {
  api: {
    baseURL: hostname,
    timeout: 20000,
  },
};



// WEBPACK FOOTER //
// ./src/config/index.js